import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import swal from 'sweetalert2';
import { DataService } from '../../../../services/data.service';
import { IssueService } from '../../../../services/issue.service';
import { getQueryParamFromAncestorRoute } from '../../../../utilities/route.utilities';

@Component({
    selector: 'issue-billed-in-sla-grid-item',
    templateUrl: './issues-billed-in-sla-grid-item.component.html',
})
export class IssuesBilledInSlaGridItemComponent implements OnInit, OnDestroy {

    clientId: number;
    subscriptions: any[] = [];
    data: any[] = [];
    page: number = 1;
    totalPages: number = 1;
    pageSize: number = 10;
    siteId: number;

    constructor(private issueService: IssueService,
        private route: ActivatedRoute,
        private router: Router,
        private dataService: DataService) {

        this.subscriptions.push(router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.ngOnInit();
            }
        }));
    }

    ngOnInit() {
        this.clientId = this.route.parent.parent.snapshot.params['clientId'];

        this.siteId = getQueryParamFromAncestorRoute(this.route, 'siteId');

        this.subscriptions.push(this.route
            .queryParams
            .subscribe(queryParams => {
                if (+queryParams['billedInSlaPage']) {
                    this.page = +queryParams['billedInSlaPage'];
                } else { this.page = 1 }
            }));


        this.getData();       
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    isValidDate(item: any): boolean {
        let date = new Date(item.latestBillDate);
        let yearString = date.getFullYear().toString();
        if (yearString === "1" || item.latestBillDate == null) {
            return false;
        } else {
            return true;
        }
    }

    getPage(page: number) {
        this.page = page;
        this.getData();
    }

    getData() {
        this.issueService.getIssuesBilledInSlaDetail(this.clientId, this.page, this.pageSize, this.siteId).then((result) => {
            this.data = [];
            if (result && result.items && result.items.length > 0) {
                this.data = result.items;
                this.totalPages = result.totalPages;
                this.pageSize = result.pageSize;
                this.page = result.currentPage;
            } else { this.dataService.issuesBilledInSlaGridItemComponentResolved.next(false); }
        }, error => this.dataService.issuesBilledInSlaGridItemComponentResolved.next(false))
    }

    onInfoClick() {
        swal({
            title: 'Bills issued on time',
            html: '<p style="text-align: left;">This widget highlights consumer accounts that did not receive a bill as expected in the latest billing run.</p>\
            <p style="text-align: left;">We expect to bill consumers within +/- 2 working days of the billing run date. A bill raised outside of the expected billing run could potentially cause problems for your consumers, for example varying bill amounts due to longer or shorter billing periods.</p>\
            <p style="text-align: left;">If a consumer has not been billed at all then it is likely we are awaiting further instruction from yourselves.</p>\
            <p style="text-align: left;">For further information please contact our customer services team.</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }
}
